export function transferFloorRequestToast(
  prefix: string,
  response: {
    packing_quantity_request?: { requested_quantity: number } | null;
    inventory_discrepancy_request?: { quantity: number } | null;
  },
): string {
  const parts: string[] = [];
  if (response.packing_quantity_request != null) {
    parts.push(
      `transfer quantity ${String(response.packing_quantity_request.requested_quantity)} pending approval`,
    );
  }
  if (response.inventory_discrepancy_request != null) {
    parts.push(
      `found inventory +${String(response.inventory_discrepancy_request.quantity)} pending approval`,
    );
  }
  if (parts.length === 0) {
    return prefix;
  }
  return `${prefix} ${parts.join("; ")}.`;
}
